<template>
  <!-- ROW 1
  <th
    v-if="toggleView == 'toggleIncarceration' && row == 1"
    scope="col"
    class="text-center border-0 pb-3 bg-light border-0"
    :colspan="currentCase?.IsGang ? 10 : 9"
  >
    Incarceration
  </th> -->

  <!-- ROW 2 -->
  <th
    :class="detailedView ? '' : 'fs-5 fw-bold'"
    v-if="toggleView == 'toggleIncarceration' && row == 2 && detailedView"
    scope="col"
    class="text-center text fs-8d pb-0 border-0 pt-0 m=0"
    style="white-space: nowrap"
  >
    Prior
  </th>
  <th
    :class="detailedView ? '' : 'fs-5 fw-bold'"
    v-if="toggleView == 'toggleIncarceration' && row == 2 && currentCase?.IsGang && detailedView"
    scope="col"
    class="border-0 text-center opacity-75 pt-0"
    style="white-space: nowrap"
  ></th>
  <!-- <th
    :class="detailedView ? '' : 'fs-5 fw-bold'"
    v-if="toggleView == 'toggleIncarceration' && row == 2"
    scope="col"
    class="border-0 text-center pt-1 pb-1"
    colspan="1"
  >
    Probation
  </th> -->
  <!-- <th
    v-if="toggleView == 'toggleIncarceration' && row == 2"
    scope="col"
    class="border-0 text-center pt-1 pb-1"
    colspan="1"
  >
    Jail
  </th> -->
  <!-- <th
    :class="detailedView ? '' : 'fs-5 fw-bold'"
    v-if="toggleView == 'toggleIncarceration' && row == 2"
    scope="col"
    class="border-0 text-center pt-1 pb-0"
  >
    Triad
  </th> -->
  <th
    :class="detailedView ? '' : 'fs-5 fw-bold'"
    v-if="toggleView == 'toggleIncarceration' && row == 2 && detailedView"
    scope="col"
    class="border-0 text-center opacity-75 pt-0"
    style="white-space: nowrap"
  ></th>
  <th
    :class="detailedView ? '' : 'fs-5 fw-bold'"
    v-if="toggleView == 'toggleIncarceration' && row == 2"
    scope="col"
    class="border-0 text-center"
    colspan="1"
  ></th>
  <th
    :class="detailedView ? '' : 'fs-5 fw-bold'"
    v-if="toggleView == 'toggleIncarceration' && row == 2"
    scope="col"
    class="border-0 text-center"
    colspan="1"
  ></th>
  <!-- <th
    v-if="toggleView == 'toggleIncarceration' && row == 2"
    scope="col"
    class="border-0 text-center opacity-75"
  ></th> -->
  <th
    :class="detailedView ? '' : 'fs-5 fw-bold'"
    v-if="toggleView == 'toggleIncarceration' && row == 2"
    scope="col"
    class="border-0 text-center opacity-75 pt-0"
  ></th>

  <!-- ROW 3 -->

  <th
    :class="detailedView ? '' : 'fs-5 fw-bold'"
    v-if="toggleView == 'toggleIncarceration' && row == 3 && detailedView"
    scope="col"
    class="border-0 text-center fs-8d text align-center pb-3 pt-0"
  >
    Strikes
    <!-- <select
      @input="onStrikeChange"
      class="mt-0 border-0 pr-0 pb-0 fw-bolder pl-0 ml-0 float-left pt-1"
      aria-label="form-select-sm example "
      style="width: 98px; background: transparent; font-size: 11px;"
    >
      <option value="0">Prior Strikes = 0</option>
      <option value="1">Prior Strikes = 1</option>
      <option value="2+">Prior Strikes = 2+</option>
    </select> -->
  </th>
  <th
    :class="detailedView ? '' : 'fs-5 fw-bold'"
    v-if="toggleView == 'toggleIncarceration' && row == 3 && detailedView && currentCase?.IsGang"
    scope="col"
    class="border-0 text-center text align-center p-0"
    style="font-size: 10px"
  >
    Gang
  </th>

  <!-- <th
    :class="detailedView ? '' : 'fs-5 fw-bold'"
    v-if="toggleView == 'toggleIncarceration' && row == 3"
    scope="col"
    class="border-0 text-center align-center pt-1 mt-1"
    style=""
  >
    Eligibility
  </th> -->
  <!-- 
  <th
    :class="detailedView ? '' : 'fs-5 fw-bold'"
    v-if="toggleView == 'toggleIncarceration' && row == 3"
    scope="col"
    class="border-0 text-center align-center pt-1 mt-1"
  >
    Term
  </th> -->

  <th
    :class="detailedView ? '' : 'fs-5 fw-bold'"
    v-if="toggleView == 'toggleIncarceration' && row == 3"
    scope="col"
    class="border-0 p-0"
  >
    <div class="d-flex justify-content-between" style="width: 100%">
      <div class="ta-c" :style="detailedView ? 'width: 48px':'width: 30%'">Low</div>
      <div class="ta-c" :style="detailedView ? 'width: 48px':'width: 30%'">Middle</div>
      <div class="ta-c" :style="detailedView ? 'width: 48px':'width: 30%'">Upper</div>
    </div>
    <!-- <label class="btn fs-6e fw-bolder mb-0 pb-0 mt-0 pt-0">Middle</label>
    <label class="btn fs-6e fw-bolder mb-0 pb-0 mt-0 pt-0">Upper</label> -->
  </th>

  <th
    :class="detailedView ? '' : 'fs-5 fw-bold'"
    v-if="toggleView == 'toggleIncarceration' && row == 3 && detailedView"
    scope="col"
    class="border-0 "
    style="white-space: nowrap"
  >
    Consecutive / Concurrent
  </th>
  <th 
  :class="detailedView ? '' : 'fs-5 fw-bold'"
    v-if="toggleView == 'toggleIncarceration' && row == 3"
    scope="col"
    class="border-0 ta-c">
    Principal
  </th>
  <th
    :class="detailedView ? '' : 'fs-5 fw-bold'"
    v-if="toggleView == 'toggleIncarceration' && row == 3"
    scope="col"
    class="border-0 ta-c"
  >
    Sentence
  </th>

  <th
    :class="detailedView ? '' : 'fs-5 fw-bold'"
    v-if="toggleView == 'toggleIncarceration' && row == 3"
    scope="col"
    class="border-0 ta-c "
    colspan="1"
    style=""
  >
    Delete
  </th>

  <!-- <th
    v-if="toggleView == 'toggleIncarceration' && row == 3"
    scope="col"
    class="border-0 text-center  align-center  pt-1 mt-1 "
    colspan="1"
  >    
  </th> -->
</template>

<script>
import { curry } from "lodash";

export default {
  name: "CDHIncarceration",
  props: ["row", "toggleView", "currentCase", "detailedView"],
  component: {
    //OverlayPanel
  },

  data() {
    return {};
  },

  methods: {
    toggle($event) {
      this.$emit("probationClick", $event);
      //
    },

    executeSuperStrike($event) {
      this.$emit("executeSuperStrike", $event);
    },

    onStrikeChange($event) {
      // console.log('emits strike change')
      this.$emit("onStrikeChange", $event);
    },
  },
  onMount() {
    this.case = this.currentCase;
    // console.log(this.currentCase)
  },
};
</script>

<style scoped>
label.form-check-label {
  color: var(--secondary-font) !important;
}

select {
  color: var(--secondary-font) !important;
}

.w-terms {
  width: 185px !important;
}


</style>
